shadow$provide[187] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Parent:{enumerable:true, get:function() {
  return Parent;
}}});
var require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js = require("../../primitive.js");
class Parent extends require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js.Primitive {
  static initClass() {
    this.model = require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js.Primitive.Group;
    this.traits = ["node"];
  }
}
Parent.initClass();

};